
define("json!gigaset_stocknotification/handles/gigaset_stocknotification.json", function(){ return {
	"catalog_product_view": [
		"gigaset_stocknotification/components/product/view"
	],
	"catalog_category_view": [
		"gigaset_stocknotification/components/product/list"
	],
	"gigaset_contentbridge_cms_page": [
		"gigaset_stocknotification/components/product/list"
	]
};});

